import { render, staticRenderFns } from "./CmgRewardExtrasCampaignCard.vue?vue&type=template&id=43cfdec2&scoped=true&lang=pug"
import script from "./cmg-reward-extras-campaign-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-reward-extras-campaign-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardExtrasCampaignCard.vue?vue&type=style&index=0&id=43cfdec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cfdec2",
  null
  
)

export default component.exports